import { Image } from '@acme/assets';
import { ChatWindow, type ChatWindowApi } from '@acme/features';

export interface ChatPanelProps {
  selectedUserId?: string;
  selectedUserName?: string;
  chatWindowApi: ChatWindowApi;
}

export const ChatPanel = (props: ChatPanelProps) => {
  return (
    <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-gray-100">
      {!props.selectedUserId ? (
        <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-6">
          <Image
            name="choice-chat"
            width={160}
            height={160}
            alt="Выберите чат"
          />
          <div className="flex flex-col items-center text-center">
            <p className="text-base font-medium text-gray-900">Выберите чат</p>
            <p className="text-base   text-gray-500">
              Что бы начать переписку с пользователем
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4">
            <div className="flex flex-col gap-0.5">
              <p className="text-base font-medium text-gray-900">
                {props.selectedUserName || 'Пользователь'}
              </p>
            </div>
          </div>

          <ChatWindow
            key={props.selectedUserId}
            className="flex-1 min-w-0 overflow-hidden rounded-none"
            api={props.chatWindowApi}
            autoScrollToBottomOnMount
          />
        </>
      )}
    </div>
  );
};
